import { useMemoizedFn } from 'ahooks';
import { useIntl } from 'umi';
import type Locales from '@/locales/zh_CN';

export type Keys = keyof typeof Locales;

export const useFormatMessage = () => {
  const { formatMessage } = useIntl();
  type FormatMessageParameters = Parameters<typeof formatMessage>;
  type ValuesType = FormatMessageParameters[1];
  const formatMsg = useMemoizedFn(
    (
      descriptor: Omit<FormatMessageParameters[0], 'id'> & { id: Keys },
      values?: ValuesType,
    ) => {
      return formatMessage(descriptor, values) as string;
    },
  );
  return {
    formatMessage: formatMsg,
  };
};
